import React, { PropsWithChildren, useMemo } from "react";
import "react-modern-drawer/dist/index.css";
import { useDrawer } from "../../../Store/modules/drawer/drawer";
import ModernDrawer from "react-modern-drawer";
import { Div } from "../../Kit";
import { useLanguage } from "../../../Store/modules/language";

export type DrawerProps = {
  drawerName?: string;
};

export const Drawer: React.FC<PropsWithChildren<DrawerProps>> = (props) => {
  const { drawerName, children } = props;
  const { name, dispatchCloseDrawer } = useDrawer();
  const { locale } = useLanguage();

  const isOpen = useMemo(() => drawerName === name, [drawerName, name]);

  return (
    <ModernDrawer
      open={isOpen}
      onClose={dispatchCloseDrawer}
      className="w-[291px]"
      size={291}
      direction={locale === "en" ? "left" : "right"}
    >
      <Div bg="secondary" className="h-full">
        {children}
      </Div>
    </ModernDrawer>
  );
};
